if (!wpi) {
  var wpi = {};
}

if (!wpi.mapmodule) {
  wpi.mapmodule = {};
}




// ELM PORTS LISTENING
elmApp.ports.getCurrentPosition.subscribe(function(map) {
  wpi.mapmodule.getCurrentPosition(map, function(err, curPosData) {
    if (err) {
      wpi.mapmodule.onCurPosDataErrored(err);
    } else {
      wpi.mapmodule.onCurPosDataReceived(curPosData);
    }
  });
});


elmApp.ports.drawPtAtCurPos.subscribe(function(data) {
  wpi.mapmodule.getCurrentPosition(data.map, function(err, curPosData) {
    if (err) {
      wpi.mapmodule.sendModeError(err);
      return
    }

    const coords = [ curPosData.x, curPosData.y ];
    if (data.geoZone) {
      var isWithin = wpi.mapmodule.isCoordsWithin(coords, data.geoZone);
      if (!isWithin) {
        wpi.mapmodule.sendGeoZoneNotAllowed();
        return
      }
    }

    const geomData = {
      layerKey : data.layerKey,
      geom : {
        type: "Point",
        coordinates: coords
      }
    };
    wpi.mapmodule.createPtAtCurPosAndSend(data.layerKey, curPosData, geomData);
  });
});


elmApp.ports.updateGeolocation.subscribe(function(elmdata) {
  if (elmdata.enabled) {
    wpi.mapmodule.showPosition(elmdata.map, elmdata.panAndZoomToRes, elmdata.blinking);
  } else {
    wpi.mapmodule.hidePosition(elmdata.map);
  }
});


elmApp.ports.initGoogleMap.subscribe(function(elmdata) {
  setTimeout(function() { //Let the dom get ready
    var curCenter = elmdata.map.getView().getCenter();
    var curProj = elmdata.map.getView().getProjection();
    var center = ol.proj.transform(curCenter, curProj, 'EPSG:4326');
    elmdata.map.googleMap = new google.maps.Map(document.getElementById(elmdata.divName), {
      center: {lat: center[1], lng: center[0]},
      zoom: elmdata.map.getView().getZoom(),
      mapTypeId: 'hybrid'
    });

    if (navigator.geolocation) {
      navigator.geolocation.watchPosition(
        function(position) {
          var pos = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          };

          if (!elmdata.map.googleMap.posMarker) {
            elmdata.map.googleMap.posMarker = new google.maps.Marker({
              position: pos,
              map: elmdata.map.googleMap
            });
          } else {
            elmdata.map.googleMap.posMarker.setPosition(pos);
          }
        },
        function(error) {},
        { enableHighAccuracy: true }
      );
    }
  }, 65);
});


elmApp.ports.updateLayerVisibility.subscribe(function(elmdata) {
  var layer = wpi.mapmodule.findLayerByKey(elmdata.map, elmdata.layerKey);
  layer.setVisible(!layer.getVisible());
});


elmApp.ports.updateLayerOpacity.subscribe(function(elmdata) {
  var layer = wpi.mapmodule.findLayerByKey(elmdata.map, elmdata.layerKey);
  layer.setOpacity(elmdata.opacity);
});


elmApp.ports.updateLayerStyle.subscribe(function(elmdata) {
  var layer = wpi.mapmodule.findLayerByKey(elmdata.map, elmdata.layerKey);
  var styleObj;
  if (typeof window[elmdata.style] === "function") {
    styleObj = (window[elmdata.style](elmdata.styleParams));
  } else {
    styleObj = window[elmdata.style];
  }
  layer.setStyle(styleObj.style);
  layer.styleObj = styleObj;
  wpi.mapmodule.onLegendCreated(elmdata.layerKey, styleObj.legend);
});


elmApp.ports.addGeoJSONToVectorLayer.subscribe(function(elmdata) {
  var layer = wpi.mapmodule.findLayerByKey(elmdata.map, elmdata.layerKey);
  var reader = new ol.format.GeoJSON();
  var features = reader.readFeatures(elmdata.vectorData)
  wpi.mapmodule.getVectLayerSrc(layer).addFeatures(features);
});


elmApp.ports.updateLayerVectorData.subscribe(function(elmdata) {
  var layer = wpi.mapmodule.findLayerByKey(elmdata.map, elmdata.layerKey);
  var features = wpi.mapmodule.createFeatures(
    elmdata.layerKey,
    layer.wpiVectorProps.format,
    layer.wpiVectorProps.idPath,
    layer.wpiVectorProps.subObjPath,
    layer.wpiVectorProps.subObjIdPath,
    elmdata.vectorData
  );
  wpi.mapmodule.getVectLayerSrc(layer).addFeatures(features);
  //Update click data in the possibility that some feature has changed
  wpi.mapmodule.sendClickData(elmdata.map, elmdata.map.lastClickCoords, true);
});


elmApp.ports.removeFeature.subscribe(function(elmdata) {
  var layer = wpi.mapmodule.findLayerByKey(elmdata.map, elmdata.layerKey);
  var f = wpi.mapmodule.getVectLayerSrc(layer).getFeatureById(elmdata.id);
  wpi.mapmodule.getVectLayerSrc(layer).removeFeature(f);
});


elmApp.ports.clearVectorLayer.subscribe(function(elmdata) {
  var layer = wpi.mapmodule.findLayerByKey(elmdata.map, elmdata.layerKey);
  wpi.mapmodule.getVectLayerSrc(layer).clear();
});


//This is the entry point for map modes, through adding or removing interactions
elmApp.ports.updateInteractions.subscribe(function(elmdata) {
  wpi.mapmodule.removeTempVectorLayer(elmdata.map);
  wpi.mapmodule.removeEditInteractions(elmdata.map);
  wpi.mapmodule.removeOrFreezeSelect(elmdata.map, elmdata.options);
  if (elmdata.iaType == "normal") {
    if (elmdata.map.normalModeSelectInteraction) { //Reactivate normal mode select
      elmdata.map.addInteraction(elmdata.map.normalModeSelectInteraction);
    }
  } else {
    if (elmdata.map.normalModeSelectInteraction) { //Deactivate normal mode select
      elmdata.map.removeInteraction(elmdata.map.normalModeSelectInteraction);
    }
    wpi.mapmodule.addInteractions(elmdata.map, elmdata);
  }
});


elmApp.ports.attachMapToDiv.subscribe(function(elmdata) {
  setTimeout(function() {
    elmdata.map.setTarget(null);
    elmdata.map.setTarget(elmdata.divName);
    elmdata.map.updateSize();
  }, 65);
});


elmApp.ports.resizeMap.subscribe(function(map) {
  setTimeout(function() {
    map.updateSize();
  }, 65);
});


elmApp.ports.checkIfCoordInZones.subscribe(function(elmdata) {
  for (var i=0; i<elmdata.namedGeoZones.length; i++) {
    var namedGeoZone = elmdata.namedGeoZones[i];
    var coords = [ elmdata.mapClickData.coordinate.x, elmdata.mapClickData.coordinate.y ];
    namedGeoZone.isWithin = wpi.mapmodule.isCoordsWithin(coords, namedGeoZone.geoZone);
  }
  wpi.mapmodule.sendCoordInZonesChecked(elmdata);
});


//For GeoJson only
//Pan, zoom (optional) and select (optional, in normal mode only) one or more geoObjs
elmApp.ports.panZoomSelectGeoObjs.subscribe(function(elmdata) {
  wpi.mapmodule.panZoomSelectGeoObjsAndFeatures(elmdata.map, elmdata.geoObjs, [], elmdata.panAndZoom, elmdata.select);
});


//For GeoJson only
elmApp.ports.startMerge.subscribe(function(elmdata) {
  var layer = wpi.mapmodule.findLayerByKey(elmdata.map, elmdata.selected.layerKey);
  var olWKTFormat = new ol.format.WKT();
  var olGeoJsonFormat = new ol.format.GeoJSON();
  var jstsWktwriter = new jsts.io.WKTWriter();

  try {
    var jstspolys = wpi.mapmodule.jstsGeomListFromFeatData(elmdata.selected.features);

    //Merge
    var union;
    for(var i=0; i<jstspolys.length-1; i++) {
      if (!union) {
        union = jstspolys[i].union(jstspolys[i+1]);
      }
      else {
        union = union.union(jstspolys[i+1]);
      }
    }

    //Remove old, display new
    for (var j=0; j<elmdata.selected.features.length; j++) {
      var f = wpi.mapmodule.getVectLayerSrc(layer).getFeatureById(elmdata.selected.features[j].id);
      wpi.mapmodule.getVectLayerSrc(layer).removeFeature(f);
    }
    var mergedFeature = olWKTFormat.readFeature(jstsWktwriter.write(union));
    wpi.mapmodule.getVectLayerSrc(layer).addFeature(mergedFeature);

    //New obj for elm based on first selected
    var mergedObj = JSON.parse(JSON.stringify(elmdata.selected.features[0].data)); //Deep clone first obj
    delete mergedObj._id; //New obj
    mergedObj.geometry = olGeoJsonFormat.writeGeometryObject(mergedFeature.getGeometry());
    wpi.mapmodule.onMergeEnded(mergedObj);
  }
  catch(err) {
     console.log("Error while trying to merge the selected polygons: ", err);
     wpi.mapmodule.onMergeEnded(null);
  }
});


//For GeoJson only
elmApp.ports.startSplit.subscribe(function(elmdata) {
  var layer = wpi.mapmodule.findLayerByKey(elmdata.map, elmdata.selected.layerKey);
  var geoJsonReader = new jsts.io.GeoJSONReader();
  var olWKTFormat = new ol.format.WKT();
  var olGeoJsonFormat = new ol.format.GeoJSON();
  var jstsWktwriter = new jsts.io.WKTWriter();

  try {
    var splitObjs = [];
    var divisionLine = geoJsonReader.read(elmdata.lineGeom);

    //Try to split each selected poly
    for (var i=0; i<elmdata.selected.features.length; i++) {
      var curSelObj = elmdata.selected.features[i].data;
      var polygonizer = new jsts.operation.polygonize.Polygonizer();
      var curGeomType = curSelObj.geometry.type
      if (curGeomType == 'MultiPolygon') {
        var numFeat = curSelObj.geometry.coordinates.length;
        for (var j=0; j<numFeat; j++){
          var coord = curSelObj.geometry.coordinates[j];
          var newGeom = {
              "type": "Polygon",
              "coordinates": coord
          };
          var curSelJstsPoly = wpi.mapmodule.jstsGeomFromGeom(newGeom);
          var union = curSelJstsPoly.getExteriorRing().union(divisionLine);
          //var polygonizer = new jsts.operation.polygonize.Polygonizer();
          polygonizer.add(union);
        }
      }
      else {
        var curSelJstsPoly = wpi.mapmodule.jstsGeomFromFeatData(curSelObj);
        var union = curSelJstsPoly.getExteriorRing().union(divisionLine);
        //var polygonizer = new jsts.operation.polygonize.Polygonizer();
        polygonizer.add(union);
      }

      var polygons = polygonizer.getPolygons();
      if (polygons.size() === 1) continue; //no split done
      for (var j=polygons.iterator(); j.hasNext();) {
        var newFeat = olWKTFormat.readFeature(jstsWktwriter.write(j.next()));
        //Create new obj
        var splitObj = JSON.parse(JSON.stringify(curSelObj)); //Deep clone the same wpimodel into each split
        delete splitObj._id; //Remove id -it's new
        splitObj.geometry = olGeoJsonFormat.writeGeometryObject(newFeat.getGeometry());
        splitObjs.push(splitObj);
        //Add new feature to map
        wpi.mapmodule.getVectLayerSrc(layer).addFeature(newFeat);
      }

      //Remove original poly from map
      var curSelFeature = wpi.mapmodule.getVectLayerSrc(layer).getFeatureById(elmdata.selected.features[i].id);
      wpi.mapmodule.getVectLayerSrc(layer).removeFeature(curSelFeature);
    }

    //Send split polys to elm
    wpi.mapmodule.onSplitEnded(splitObjs);
  }
  catch(err) {
    console.log("Error while trying to split the selected polygons: ", err);
    wpi.mapmodule.onSplitEnded(null);
  }
});


//For GeoJson only
elmApp.ports.startBreakup.subscribe(function(elmdata) {
  var layer = wpi.mapmodule.findLayerByKey(elmdata.map, elmdata.selected.layerKey);

  var brokenupObjs = [];
  for (var i=0; i<elmdata.selected.features.length; i++) {
    var curSelObj = elmdata.selected.features[i].data;
    var curSelFeature = wpi.mapmodule.getVectLayerSrc(layer).getFeatureById(elmdata.selected.features[i].id);
    var curSelGeom = curSelFeature.getGeometry();
    var curSelGeomType = curSelGeom.getType();

    //Break up multi geom
    var newGeoms;
    if (curSelGeomType == "MultiPolygon") newGeoms = curSelGeom.getPolygons();
    else if (curSelGeomType == "MultiLineString") newGeoms = curSelGeom.getLineStrings();
    else if (curSelGeomType == "MultiPoint") newGeoms = curSelGeom.getPoints();
    else break;

    //Display in map: remove original poly from map
    wpi.mapmodule.getVectLayerSrc(layer).removeFeature(curSelFeature);

    //For each child, giv a deep cloned parent model, minus the _id
    var olGeoJsonFormat = new ol.format.GeoJSON();
    for (var j=0; j<newGeoms.length; j++) {
      var clonedObj = JSON.parse(JSON.stringify(curSelObj));
      delete clonedObj._id;
      clonedObj.geometry = olGeoJsonFormat.writeGeometryObject(newGeoms[j]);
      brokenupObjs.push(clonedObj);

      //Display in map: add new obj to layer
      var newFeat = new ol.Feature(newGeoms[j]);
      wpi.mapmodule.getVectLayerSrc(layer).addFeature(newFeat);
    }
  }

  //Send broken up geom objs to elm
  wpi.mapmodule.onBreakupEnded(brokenupObjs);
});


elmApp.ports.initOpenLayerBtn.subscribe(function(elmdata) {
  var fileInput = document.getElementById('openLayerFileInput');
  if (!fileInput) {
    fileInput = document.createElement('input');
    fileInput.style.display='none';
    fileInput.id = 'openLayerFileInput'
    fileInput.type='file';
    fileInput.accept = ".json,.geojson,.shp"
    fileInput.addEventListener('change', function() {
      if (!fileInput.files || !fileInput.files.length || !fileInput.files[0]) {
        return;
      }
      var curFile = fileInput.files[0];
      if (!curFile.name) return;
      var layerName = curFile.name;
      if (wpi.mapmodule.findLayerByKey(elmdata.map, layerName)) {
        console.log("Layer already exists");
        return;
      }
      var layerInfo = {
        type: "Vector",
        format: "GeoJson",
        key: curFile.name,
        isVisible: true,
        opacity: 1
      };
      var splitName = curFile.name.split('.');
      if (!splitName || !splitName.length || splitName.length < 2) return;
      var curFileType = splitName.pop();
      var fileReader = new FileReader();
      if (curFileType === "shp") {
        fileReader.onload = function() {
          try {
            layerInfo.initData = shp.parseShp(this.result);
            for (var i=0; i<layerInfo.initData.length; i++) {
              layerInfo.initData[i] = { //.shp file contains only geometries
                geometry: layerInfo.initData[i]
              }
            }
            elmdata.map.addLayer(wpi.mapmodule.createLayers(elmdata.map, [layerInfo])[0]);
          }
          catch(e) {
            console.log(e);
          }
        };
        fileReader.onerror = function() {
          console.log(fileReader.error);
        };
        fileReader.readAsArrayBuffer(curFile);
      }
      else if (curFileType === "json" || curFileType === "geojson") {
        fileReader.onload = function() {
          try {
            layerInfo.initData = JSON.parse(fileReader.result);
            elmdata.map.addLayer(wpi.mapmodule.createLayers(elmdata.map, [layerInfo])[0]);
          }
          catch(e) {
            console.log(e);
          }
        };
        fileReader.onerror = function() {
          console.log(fileReader.error);
        };
        fileReader.readAsText(curFile);
      }
      else {
        console.log("File type not supported ", curFileType);
        return;
      }
    });
    document.getElementsByTagName('body')[0].appendChild(fileInput);
  }

  var openLayerFileBtn = document.getElementById(elmdata.divName);
  if (!openLayerFileBtn.onclick) {
    openLayerFileBtn.onclick = function() {
      fileInput.click();
    };
  }
});


elmApp.ports.disableDrawIA.subscribe(function(elmdata) {
  elmdata.map.getInteractions().forEach(function(interaction) {
    if (interaction instanceof ol.interaction.Draw) {
      interaction.setActive(false);
    }
  });
});


elmApp.ports.captureCanvas.subscribe(function(elmdata) {
  const canvas = document.getElementsByTagName("canvas")[0];
  // This returns the canvas as a base64 image
  const imageB64 = canvas.toDataURL('image/png');
  const data = { image: imageB64, canvasDimensions: { height: canvas.height, width: canvas.width } };
  wpi.mapmodule.sendCapturedCanvas(data);
});


elmApp.ports.panAndZoom.subscribe(function(elmdata) {
  wpi.mapmodule.panAndZoom(elmdata.map, elmdata.geoObjs, elmdata.zoom);
});



// HELPERS

wpi.mapmodule.panAndZoom = function(map, geoObjs, zoom) {
  var featuresForResExt = [];
  var reader = new ol.format.GeoJSON();

  //Complete the three feature arrays with the geoObjs
  for (var i=0; i<geoObjs.length; i++) {
    var feature;
    var geoObj = geoObjs[i];
    var layer = wpi.mapmodule.findLayerByKey(map, geoObj.layerKey);
    if (!layer && !geoObj.id) continue;
    //first, try to find in map
    feature = wpi.mapmodule.getVectLayerSrc(layer).getFeatureById(geoObj.id);
    if (feature) {
      featuresForResExt.push(feature);
      continue; //ok, found in map
    }
    //not in map, create and add to resExt array for calculation
    //do not add to map: the model is not necessarily right
    //it might be loaded properly later when zooming in
    if (!feature && !geoObj.obj) continue;
    geoObj.obj.type = "Feature"; //This invariant is typically not set in our models
    feature = reader.readFeature(geoObj.obj);
    if (!feature) continue;
    feature.layerKey = geoObj.layerKey;
    featuresForResExt.push(feature);
  }

  var overallExtent;
  var maxResolution = 10000;

  for (var j=0; j<featuresForResExt.length; j++) {
    var resExtFeature = featuresForResExt[j];
    var layer = wpi.mapmodule.findLayerByKey(map, resExtFeature.layerKey);
    if (layer.getMaxResolution() < maxResolution) {
      maxResolution = layer.getMaxResolution();
    }
    if (!overallExtent) {
      overallExtent = resExtFeature.getGeometry().getExtent().slice();
    } else {
      overallExtent = ol.extent.extend(overallExtent, resExtFeature.getGeometry().getExtent());
    }
  }

  if (overallExtent) {
    var resolution = map.getView().getResolutionForExtent(overallExtent) + 2;
    if (resolution > maxResolution) resolution = maxResolution-0.2;
    map.getView().animate({
      center: ol.extent.getCenter(overallExtent),
      resolution: resolution,
      zoom: zoom
    });
  }
};


wpi.mapmodule.panZoomSelectGeoObjsAndFeatures = function(map, geoObjs, features, panAndZoom, select) {
  var foundMapFeatures = features;
  var featuresForResExt = features.slice(); //Otherwise, same as above!
  var missingGeoObjs = [];
  var reader = new ol.format.GeoJSON();

  //Complete the three feature arrays with the geoObjs
  for (var i=0; i<geoObjs.length; i++) {
    var feature;
    var geoObj = geoObjs[i];
    var layer = wpi.mapmodule.findLayerByKey(map, geoObj.layerKey);
    if (!layer && !geoObj.id) continue;
    //first, try to find in map
    feature = wpi.mapmodule.getVectLayerSrc(layer).getFeatureById(geoObj.id);
    if (feature) {
      foundMapFeatures.push(feature);
      featuresForResExt.push(feature);
      continue; //ok, found in map
    }
    //not in map, create and add to resExt array for calculation
    //do not add to map: the model is not necessarily right
    //it might be loaded properly later when zooming in
    if (!feature && !geoObj.obj) continue;
    geoObj.obj.type = "Feature"; //This invariant is typically not set in our models
    feature = reader.readFeature(geoObj.obj);
    if (!feature) continue;
    feature.layerKey = geoObj.layerKey;
    featuresForResExt.push(feature);
    missingGeoObjs.push(geoObj);
  }

  //If panAndZoom, calculate extent and res, then pan and zoom
  if (panAndZoom) {
    var overallExtent;
    var maxResolution = 10000;

    for (var j=0; j<featuresForResExt.length; j++) {
      var resExtFeature = featuresForResExt[j];
      var layer = wpi.mapmodule.findLayerByKey(map, resExtFeature.layerKey);
      if (layer.getMaxResolution() < maxResolution) {
        maxResolution = layer.getMaxResolution();
      }
      if (!overallExtent) {
        overallExtent = resExtFeature.getGeometry().getExtent().slice(); //Get a clone, not the ref
      } else {
        overallExtent = ol.extent.extend(overallExtent, resExtFeature.getGeometry().getExtent());
      }
    }

    if (overallExtent) {
      var resolution = map.getView().getResolutionForExtent(overallExtent) + 2;
      if (resolution > maxResolution) resolution = maxResolution-0.2;
      map.getView().animate({
        center: ol.extent.getCenter(overallExtent),
        resolution: resolution
      });
    }
  }

  // If select is required, and not yet in mode-based select
  // Now we possibly zoomed in, which may trigger the loading process of some currently missing features
  // If not found, we will wait a bit and retry
  if (select && !map.selectInteraction) {
    //make sure map.normalModeSelectInteractionLayers exists
    wpi.mapmodule.updateNormalModeSelectInteraction(map, null);
    wpi.mapmodule.waitGetFeaturesFromGeoObjs(map, missingGeoObjs, foundMapFeatures, 0, function(foundFeatures) {
      if (foundFeatures.length === 0) { //No objects passed, let's assume emptying the selection is what is required
        map.normalModeSelectInteraction.getFeatures().clear();
      } else {
        for (var k=0; k<foundFeatures.length; k++) {
          map.normalModeSelectInteraction.getFeatures().push(foundFeatures[k]);
        }
      }
    });
  }

};


wpi.mapmodule.jstsGeomListFromFeatData = function(features) {
  var jstsList = [];
  for (var i=0; i<features.length; i++) {
    var jstsGeom = wpi.mapmodule.jstsGeomFromFeatData(features[i].data)
    jstsList.push(jstsGeom);
  }
  return jstsList;
};


wpi.mapmodule.jstsGeomFromFeatData = function(obj) {
  var reader = new jsts.io.GeoJSONReader();
  var jstsGeom = reader.read(obj.geometry);
  return jstsGeom;
};

wpi.mapmodule.jstsGeomFromGeom = function(geom) {
  var reader = new jsts.io.GeoJSONReader();
  var jstsGeom = reader.read(geom);
  return jstsGeom;
};

wpi.mapmodule.removeEditInteractions = function(map) {
  if (!map.editInteractions) return;
  for (var i=0; i<map.editInteractions.length; i++) {
    var editIA = map.editInteractions[i];
    map.removeInteraction(editIA);
  }
  map.editInteractions = null;
};


wpi.mapmodule.removeOrFreezeSelect = function(map, options) {
  if (map.selectInteraction) {
    if (options && options.freezeSelection) {
      map.selectInteraction.setActive(false);
    }
    else {
      map.removeInteraction(map.selectInteraction);
      map.selectInteraction = null;
    }
  }
};


wpi.mapmodule.addInteractions = function(map, iaData) {
  if (!map.editInteractions) map.editInteractions = [];
  switch(iaData.iaType) {
    case "select":
      wpi.mapmodule.addSelectIA(map, iaData);
      break;
    case "draw":
      wpi.mapmodule.addDrawIA(map, iaData);
      break;
    case "modify":
      wpi.mapmodule.addModifyIA(map, iaData);
      break;
    default:
      console.log("Error: no such interaction: " + iaData.iaType);
  }
};


wpi.mapmodule.addSelectIA = function(map, iaData) {
  var layers = [];
  for (var i=0; i<iaData.options.layerKeys.length; i++) {
    var layer = wpi.mapmodule.findLayerByKey(map, iaData.options.layerKeys[i]);
    layers.push(layer);
  }
  wpi.mapmodule.addTempEditGeoZone(map,iaData.options.geoZone);
  var selectIaOpts = {
    style : wpi.mapmodule.createSelectStyleFn(map),
    filter : function(feature, layer) {
      if (!iaData.options.onlyMulti) return true;
      else {
        var geomType = feature.getGeometry().getType();
        return (geomType == "MultiPoint" || geomType == "MultiLineString" || geomType == "MultiPolygon");
      }
    },
    condition: function(mapBrowserEvt) {
      var isOkDefault = ol.events.condition.singleClick(mapBrowserEvt); //default
      if (!isOkDefault) return false;
      return wpi.mapmodule.checkGeoZone(mapBrowserEvt.coordinate, iaData.options.geoZone);
    },
    toggleCondition: function(mapBrowserEvt) {
      return ol.events.condition.singleClick(mapBrowserEvt); //default is using shift key
    }
  };
  if (layers.length > 0) {
    selectIaOpts.layers = layers
  }
  var selectIA = new ol.interaction.Select(selectIaOpts);
  selectIA.on('select', function(evt) {
    wpi.mapmodule.onSelectionUpdated(wpi.mapmodule.getFeaturesFromSelIA(selectIA));
  });
  map.selectInteraction = selectIA;
  map.addInteraction(selectIA);
  wpi.mapmodule.waitGetFeaturesFromGeoObjs(map, iaData.options.initGeoObjs, [], 0, function(foundFeatures) {
    for (var i=0; i<foundFeatures.length; i++) {
      selectIA.getFeatures().push(foundFeatures[i]);
    }
    wpi.mapmodule.onSelectionUpdated(wpi.mapmodule.getFeaturesFromSelIA(selectIA));
  });
};



wpi.mapmodule.addDrawIA = function(map, iaData) {
  var layer = wpi.mapmodule.findLayerByKey(map, iaData.options.layerKey);
  wpi.mapmodule.addTempEditGeoZone(map,iaData.options.geoZone);
  var drawIA = new ol.interaction.Draw({
    type: iaData.options.shapeType,
    source: wpi.mapmodule.getVectLayerSrc(layer),
    condition: function(mapBrowserEvt) {
      var isOkDefault = ol.events.condition.noModifierKeys(mapBrowserEvt); //default
      if (!isOkDefault) return false;
      return wpi.mapmodule.checkGeoZone(mapBrowserEvt.coordinate, iaData.options.geoZone);
    }
  });

  //Draw
  drawIA.on('drawend', function(evt) {
    wpi.mapmodule.onDrawDone(iaData.options.layerKey, evt.feature, iaData.options.id);
    if (iaData.options.shapeType != "MultiLineString") {
      drawIA.setActive(false); // If MultiLineString, we invoke interaction cancel from ELM.
    }
  });
  map.editInteractions.push(drawIA);
  map.addInteraction(drawIA);

  //Snap
  if (iaData.options.snap) {
    var snapIA = new ol.interaction.Snap({
      source: wpi.mapmodule.getVectLayerSrc(layer)
    });
    map.editInteractions.push(snapIA);
    map.addInteraction(snapIA);
  }

  var snapLayerKeys = iaData.options.snapLayerKeys;
  if (snapLayerKeys) {
    snapLayerKeys.forEach(function(snapLayerKey) {
      var layer = wpi.mapmodule.findLayerByKey(map, snapLayerKey);
      if (layer) {
        var snapIA = new ol.interaction.Snap({
          source: wpi.mapmodule.getVectLayerSrc(layer)
        });
        map.addInteraction(snapIA);
      }
    });
  }
};


wpi.mapmodule.addModifyIA = function(map, iaData) {
  var layer = wpi.mapmodule.findLayerByKey(map, iaData.options.layerKey);
  wpi.mapmodule.addTempEditGeoZone(map,iaData.options.geoZone);

  //Select before modifying
  var selectIA = new ol.interaction.Select({
    style : wpi.mapmodule.createSelectStyleFn(map),
    layers: [ layer ],
    condition: function(mapBrowserEvt) {
      var isOkDefault = ol.events.condition.singleClick(mapBrowserEvt); //default
      if (!isOkDefault) return false;
      return wpi.mapmodule.checkGeoZone(mapBrowserEvt.coordinate, iaData.options.geoZone);
    }
  });
  map.selectInteraction = selectIA;
  map.addInteraction(selectIA);

  //Modify
  var modifyIA = new ol.interaction.Modify({
    features: selectIA.getFeatures(), //We can't use wpi.mapmodule.getFeaturesFromSelIA, because we need a proper ol.Collection with event listeners when sel changed; the downside is that this will enable editing clusters as well
    condition: function(mapBrowserEvt) {
      var isOkDefault = ol.events.condition.primaryAction(mapBrowserEvt); //default
      if (!isOkDefault) return false;
      return wpi.mapmodule.checkGeoZone(mapBrowserEvt.coordinate, iaData.options.geoZone);
    },
    deleteCondition: function(mapBrowserEvt) {
      var isDoubleClick = ol.events.condition.doubleClick(mapBrowserEvt); //double-click is the chosen prerequisite
      if(!isDoubleClick) return false;
      return wpi.mapmodule.checkGeoZone(mapBrowserEvt.coordinate, iaData.options.geoZone);
    }
  });
  modifyIA.on('modifyend', function(evt) {
      wpi.mapmodule.onModifsUpdated(iaData.options.layerKey, evt.features.getArray());
  });
  map.editInteractions.push(modifyIA);
  map.addInteraction(modifyIA);

  //Snap
  if (iaData.options.snap) {
    var snapIA = new ol.interaction.Snap({
      source: wpi.mapmodule.getVectLayerSrc(layer)
    });
    map.editInteractions.push(snapIA);
    map.addInteraction(snapIA);
  }
};


wpi.mapmodule.checkGeoZone = function(coords, geoZone) {
  if (!geoZone || !coords) return true;
  var isWithin = wpi.mapmodule.isCoordsWithin(coords, geoZone);
  if (!isWithin) {
    wpi.mapmodule.sendGeoZoneNotAllowed();
    return false;
  } else{
    wpi.mapmodule.sendNoError();
    return true;
  }
};


wpi.mapmodule.isCoordsWithin = function(coords, geoZone) {
  var geoJsonCoords = {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": coords
    }
  };
  if (!geoZone.geometry && geoZone.type) { //To geojson obj
    geoZone = {
      "type": "Feature",
      "geometry": geoZone
    }
  };
  try {
    var jstsCoords = wpi.mapmodule.jstsGeomFromFeatData(geoJsonCoords);
    var jstsGeoZone = wpi.mapmodule.jstsGeomFromFeatData(geoZone);
    return jstsGeoZone.intersects(jstsCoords);
  }
  catch(err) {
    console.log("Error while trying to check coordinates in geo zone: ", err);
    return false;
  }
};


wpi.mapmodule.addTempEditGeoZone = function(map,geoZone) {
  if (!geoZone) return;
  if (!geoZone.geometry && geoZone.type) { //To geojson obj
    geoZone = {
      "type": "Feature",
      "geometry": geoZone
    }
  };
  var style = new ol.style.Style({
    fill: new ol.style.Fill({ color: 'rgba(0,0,0,0)' }),
    stroke: new ol.style.Stroke({ color: 'rgba(200,0,0,1)', width: 4 })
  });
  wpi.mapmodule.createTempVectorLayer(map, [geoZone], style);
};
